import React, { memo } from 'react'

import classNames from 'classnames'
import linkConnector from 'root/src/client/logic/app/connectors/linkConnector'
import {
	linkColor, linkHoverColor, navLinkStyle,
} from 'root/src/client/web/commonStyles'
import Link from 'next/link'
import { comparePropsFn } from 'root/src/shared/util/stateCompare'

const styles = {
	link: {
		cursor: 'pointer',
		textDecoration: 'none',
		color: linkColor,
		'&:visited': {
			color: linkColor,
		},
		'&:hover': {
			color: linkHoverColor,
		},
	},
	navStyle: navLinkStyle,
	navMenuStyle: {
		fontSize: 16,
		fontWeight: 500,
		textDecoration: 'none',
		color: linkColor,
		'&:visited': {
			color: linkColor,
		},
		'&:hover': {
			color: linkHoverColor,
		},
		display: 'block',
	},
}

export const BaseLink = memo(({
	linkHref, linkTarget, children,	navStyle, navMenuStyle, classes, className, style, onClick,
	handleAuthenticationRouting,
}) => (
	<Link href={linkHref}>
		<a
			className={classNames(
				{
					[classes.link]: !navStyle && !navMenuStyle,
					[classes.navStyle]: navStyle,
					[classes.navMenuStyle]: navMenuStyle,
					'layout-column layout-align-center-center': navStyle,
					'flex layout-column layout-align-center': navMenuStyle,
				},
				className,
			)}
			style={style}
			rel="noopener noreferrer"
			href={linkHref}
			target={linkTarget}
			onClick={(e) => {
				const { onClickMod } = handleAuthenticationRouting({
					linkHref,
					onClick,
				})
				if (onClickMod) {
					onClickMod(e)
				}
			}}
		>
			{children}
		</a>
	</Link>
), comparePropsFn([
	'linkHref', 'linkTarget', 'routeId', 'routeParams', 'username', 'hasProfile', 'children',
]))

export default linkConnector(BaseLink, styles, 'MuiLink')
